import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
export var i18nInstance = i18n;
export var initializeI18n = function (lang) {
    i18n
        .use(HttpApi)
        .use(initReactI18next)
        .init({
        lng: lang,
        fallbackLng: "en",
        debug: false,
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json",
        },
        interpolation: {
            escapeValue: false,
        },
    });
    return i18n;
};
